<template>
    <div class="StepHead">
        <div class="Steps">
            <div class="StepsItem">2. 专业信息</div>
        </div>
        <div v-if="TypeId==1" class="StepHeadTit" style="margin-bottom: 0">* 符合下列条件之一，可直接申请注册</div>
        <div v-if="TypeId==2" class="StepHeadTit" style="margin-bottom: 0">* 注册心理服务专业机构:注册单位可根据情况选择申请  <span style="color: #ff4b4e;">（上传的所有资料均需加盖公章）</span></div>
        <div :class="TypeId==1 ? 'StepJiBen1' : 'StepJiBen'">
            <div class="StepJiBenItem">
                <div :class="TypeId==1 ? 'StepJiBenItemTit1' : ''" class="StepJiBenItemTit"><span class="Icon">*</span><span class="Tit">{{TypeId==1?'注册级别':'注册心理服务专业机构'}}</span></div>
                <div class="StepJiBenItemVal">
                    <el-select class="WidMax" v-if="TypeId==1" v-model="user_group_id" placeholder="请选择注册级别" @change="ChangeData" :disabled="$route.query.type && hasUserGroup">
                        <el-option :label="item.name" :value="item.id" v-for="item in TypeData" :key="item.id"></el-option>
                    </el-select>
                    <el-checkbox-group v-model="user_group_id" v-if="TypeId==2"  @change="ChangeData" :disabled="$route.query.type && hasUserGroup">
                        <el-checkbox :label="String(item.id)" :value="String(item.id)" v-for="item in TypeData" :key="item.id" :disabled="$route.query.type && hasUserGroup">{{item.name}}</el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>
            <!-- <div class="StepJiBenItem" v-if="TypeId==1 && FormData">
                <div class="StepJiBenItemTit"><span class="Icon">*</span><span class="Tit">注册类型</span></div>
                <div class="StepJiBenItemVal">
                    <el-select class="WidMax" v-model="SeleId" placeholder="请选择注册类型" @change="ShowData">
                        <el-option :label="item.name" :value="item.id" v-for="item in FormData" :key="item.id"></el-option>
                    </el-select>
                </div>
            </div> -->
        </div>
        <div class="StepJiBenBox" v-if="TypeId==1 && FormData">
            <el-card class="box-card">
                <div slot="header" class="StepJiBenItemTit StepJiBenItemTit1">
                    <span class="Icon">*</span><span class="Tit">注册类型</span>
                </div>
                <div class="StepJiBenRadio" v-for="(item, index) in FormData" :key="index">
                    <input class="radio" type="radio" :id="'option' + index" :value="item.id" v-model="selected" @change="ShowData(item.id)"/>
                    <label class="radio-label" :for="'option' + index">{{ item.name }}</label>
                </div>
            </el-card>
        </div>
        <div class="StepComm" v-if="SeleData">
            <div class="TitleBox TitleBoxAuto" v-if="isGroup8Selected">
                类别
                <el-checkbox-group v-model="selectedGroup8ItemIds" size="small" class="MarLe">
                    <el-checkbox v-for="opt in group8Options" :key="opt.value" :label="opt.value">{{ opt.label }}</el-checkbox>
                </el-checkbox-group>
            </div>
            <div v-for="(item,index) in SeleData" :key="item.id">
                <div class="TitleBox" v-if="TypeId==2 && item.question_list_id_one"> 
                    <span v-for="(t, index) in TypeData" :key="index" v-if="item.question_list_id_one == t.id">{{ t.name }}</span>
                </div>
                <!-- <div v-for="(t, index) in TypeData" :key="index">
                    <div class="TitleBox" v-if="TypeId==2 && item.question_list_id_one == t.id && t.id == 8"> 
                        项目 
                        <el-select style="width: 600px;" class="WidMax" v-model="item.schools" multiple collapse-tags placeholder="请选择项目" clearable>
                            <el-option v-for="option in item.question_list" :key="option.id" :label="option.name" :value="option.id"></el-option>
                        </el-select>
                    </div>
                </div> -->
                <div class="StepCommItem" v-if="!isGroup8Selected || item.question_list_id !== 8 || selectedGroup8ItemIds.includes(item.id)">
                    <div class="StepCommNum" v-if="TypeId==2">{{index+1}}.</div>
                    <div class="StepCommHead">
                        <div class="StepCommFile MarTop" v-if="item.type == 1||item.type == 4">
                            <div class="StepCommFileTit">{{item.name}}{{item.type == 4 ? ' (可选)' : ''}}</div>
                            <div class="StepCommFileTxt">
                                <el-upload action="none" size="small" multiple :show-file-list="false" :http-request="(file)=>UpFile(file,item,1)">
                                  <el-button class="MarLe" type="primary" size="mini">上传</el-button>
                                </el-upload>
                                <div class="StepCommFileMsg">（上传pdf、jpg等格式文件）{{item.type == 4 ? '，此项为可选' : ''}}</div>
                                <div class="StepCommFileImg" v-if="item.file.length>0" v-for="(i,s) in item.file">
                                    <img :src="$Global._isFileName(i)" alt="" @click="OpenLock(i)">
                                    <i class="iconfont icon-guanbi2fill" @click="CloseImg('fu',index,s)"></i>
                                </div>
                                <el-button class="MarLe" v-if="item.template_file !== ''" type="primary" size="mini" @click="DownFile(item.template_file)">下载模板</el-button>
                                <el-upload action="none" v-if="item.is_template != 0" size="small" multiple :show-file-list="false" :http-request="(file)=>UpFile(file,item,2)">
                                  <el-button class="MarLe" type="primary" size="mini">上传</el-button>
                                </el-upload>
                                <div class="StepCommFileImg" v-if="item.templatefile.length>0" v-for="(i,s) in item.templatefile">
                                    <img :src="$Global._isFileName(i)" alt="" @click="OpenLock(i)">
                                    <i class="iconfont icon-guanbi2fill" @click="CloseTempImg('fu',index,s)"></i>
                                </div>
                            </div>
                        </div>
                        <div class="StepCommIpt MarTop" v-if="item.type == 2">
                            <div class="StepCommIptTxt">{{item.name}}</div>
                            <div class="StepCommIptVal">
                                <el-input v-if="item.type_str != 3" size="small" placeholder="请输入" v-model="item.val" @input="handleInputChange(item)" @blur="ValidateOnComplete(item)"></el-input>
                                <el-date-picker
                                    v-else
                                    v-model="item.val"
                                    type="date"
                                    placeholder="选择日期"
                                    value-format="yyyy-MM-dd"
                                    @input="$forceUpdate()">
                                </el-date-picker>
                            </div>
                            <div class="StepCommIptTime">{{item.unit}}</div>
                            <el-button class="MarLe" v-if="item.template_file !== ''" type="primary" size="mini" @click="DownFile(item.template_file)">下载模板</el-button>
                            <el-upload action="none" v-if="item.is_template != 0" size="small" multiple :show-file-list="false" :http-request="(file)=>UpFile(file,item,2)">
                              <el-button class="MarLe" type="primary" size="mini">上传</el-button>
                            </el-upload>
                            <div class="StepCommFileImg" v-if="item.templatefile.length>0" v-for="(i,s) in item.templatefile">
                                <img :src="$Global._isFileName(i)" alt="" @click="OpenLock(i)">
                                <i class="iconfont icon-guanbi2fill" @click="CloseTempImg('fu',index,s)"></i>
                            </div>
                        </div>
                        <div class="StepCommIpt MarTop" v-if="item.type==3">
                            <div class="StepCommIptTxt" :class="{'StepFontWeight':TypeId==1}">{{item.name}}</div>
                            <el-button class="MarLe" v-if="item.template_file" type="primary" size="mini" @click="DownFile(item.template_file)">下载模板</el-button>
                            <el-upload action="none" v-if="item.template_file" size="small" multiple :show-file-list="false" :http-request="(file)=>UpFile(file,item,2)">
                              <el-button class="MarLe" type="primary" size="mini">上传</el-button>
                            </el-upload>
                            <div class="StepCommFileImg" v-if="item.templatefile.length>0" v-for="(i,s) in item.templatefile">
                                <img :src="$Global._isFileName(i)" alt="" @click="OpenLock(i)">
                                <i class="iconfont icon-guanbi2fill" @click="CloseTempImg('fu',index,s)"></i>
                            </div>
                        </div>
                        <!-- <div class="MarTop" v-if="item.is_supervisor==1">
                            <div class="SupervisorHead" v-for="(items,indexs) in item.supervisor">
                                <div class="SupervisorItem">
                                    <div>督导师姓名</div>
                                    <el-input class="Wid120" size="small" placeholder="请输入" v-model="items.name"></el-input>
                                </div>
                                <div class="SupervisorItem">
                                    <div>注册码</div>
                                    <el-input class="Wid120" size="small" placeholder="请输入" v-model="items.code"></el-input>
                                </div>
                                <div class="SupervisorItem">
                                    <div>电话</div>
                                    <el-input class="Wid120" size="small" placeholder="请输入" v-model="items.mobile"></el-input>
                                </div>
                                <div class="SupervisorItem" v-if="indexs==0"><el-button class="MarLe" type="primary" size="mini" @click="supervisorAdd(item)">添加</el-button></div>
                                <div class="SupervisorItem" v-else><el-button class="MarLe" type="error" size="mini" @click="supervisorDel(item,indexs)">删除</el-button></div>
                            </div>
                        </div> -->
                        <div v-for="(items,indexs) in item.children" :key="items.id">
                            <div class="StepCommFile MarTop" v-if="items.type==1 || items.type==4">
                                <div class="RoundBox" v-if="TypeId==1"></div>
                                <div class="StepCommFileTit">{{items.name}}{{items.type == 4 ? ' (可选)' : ''}}</div>
                                <div class="StepCommFileTxt">
                                    <el-upload action="none" size="small" :multiple="items.type==4" :show-file-list="false" :http-request="(file)=>UpFile(file,items,1)">
                                      <el-button class="MarLe" type="primary" size="mini">上传</el-button>
                                    </el-upload>
                                    <div class="StepCommFileMsg">（上传pdf、jpg等格式文件）{{items.type == 4 ? '，此项为可选' : ''}}</div>
                                    <div class="StepCommFileImg" v-if="items.file.length>0" v-for="(i,s) in items.file">
                                        <img :src="$Global._isFileName(i)" alt="" @click="OpenLock(i)">
                                        <i class="iconfont icon-guanbi2fill" @click="CloseImg('child',index,indexs,s)"></i>
                                    </div>
                                    <el-button class="MarLe" v-if="items.template_file" type="primary" size="mini" @click="DownFile(items.template_file)">下载模板</el-button>
                                    <el-upload action="none" v-if="items.template_file" size="small" multiple :show-file-list="false" :http-request="(file)=>UpFile(file,items,2)">
                                      <el-button class="MarLe" type="primary" size="mini">上传</el-button>
                                    </el-upload>
                                    <div class="StepCommFileImg" v-if="items.templatefile.length>0" v-for="(i,s) in items.templatefile">
                                        <img :src="$Global._isFileName(i)" alt="" @click="OpenLock(i)">
                                        <i class="iconfont icon-guanbi2fill" @click="CloseTempImg('child',index,indexs,s)"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="StepCommIpt MarTop" v-if="items.type==2">
                                <div class="RoundBox" v-if="TypeId==1"></div>
                                <div class="StepCommIptTxt">{{items.name}}</div>
                                <div class="StepCommIptVal">
                                    <el-input size="small" v-if="items.type_str != 4 && items.type_str != 3" placeholder="请输入" v-model="items.val" @input="handleInputChange(items)" @blur="ValidateOnComplete(items)"></el-input>
                                    <el-select v-if="items.type_str == 4" style="width: 200px;" v-model="items.val" size="small" placeholder="请选择" class="MarLe" multiple collapse-tags clearable @change="$forceUpdate()">
                                        <el-option v-for="(option, option_index) in items.option_value.split(',')" :key="option_index" :label="option" :value="option"></el-option>
                                    </el-select>
                                    <el-date-picker
                                        v-if="items.type_str == 3"
                                        v-model="items.val"
                                        type="date"
                                        placeholder="选择日期"
                                        value-format="yyyy-MM-dd"
                                        @input="$forceUpdate()">
                                    </el-date-picker>
                                </div>
                                <div class="StepCommIptTime">{{items.unit}}</div>
                                <el-button class="MarLe" v-if="items.template_file !== ''" type="primary" size="mini" @click="DownFile(items.template_file)">下载模板</el-button>
                                <el-upload action="none" v-if="items.is_template != 0" size="small" multiple :show-file-list="false" :http-request="(file)=>UpFile(file,items,2)">
                                  <el-button class="MarLe" type="primary" size="mini">上传</el-button>
                                </el-upload>
                                <div class="StepCommFileImg" v-if="items.templatefile.length>0" v-for="(i,s) in items.templatefile">
                                    <img :src="$Global._isFileName(i)" alt="" @click="OpenLock(i)">
                                    <i class="iconfont icon-guanbi2fill" @click="CloseTempImg('child',index,indexs,s)"></i>
                                </div>
                            </div>
                            <div class="StepCommIpt MarTop" v-if="items.type==3">
                                <div class="RoundBox" v-if="TypeId==1"></div>
                                <div class="StepCommIptTxt">{{items.name}}</div>
                                <el-button class="MarLe" v-if="items.template_file !== ''" type="primary" size="mini" @click="DownFile(items.template_file)">下载模板</el-button>
                                <el-upload action="none" v-if="items.is_template != 0" size="small" multiple :show-file-list="false" :http-request="(file)=>UpFile(file,items,2)">
                                  <el-button class="MarLe" type="primary" size="mini">上传</el-button>
                                </el-upload>
                                <div class="StepCommFileImg" v-if="items.templatefile.length>0" v-for="(i,s) in items.templatefile">
                                    <img :src="$Global._isFileName(i)" alt="" @click="OpenLock(i)">
                                    <i class="iconfont icon-guanbi2fill" @click="CloseTempImg('child',index,indexs,s)"></i>
                                </div>
                            </div>
                            <!-- <div class="MarTop" v-if="items.is_supervisor==1">
                                <div class="SupervisorHead" v-for="(itemss,indexs) in items.supervisor">
                                    <div class="RoundBox" v-if="TypeId==1"></div>
                                    <div class="SupervisorItem">
                                        <div>督导师姓名</div>
                                        <el-input class="Wid120" size="small" placeholder="请输入" v-model="itemss.name"></el-input>
                                    </div>
                                    <div class="SupervisorItem">
                                        <div>注册码</div>
                                        <el-input class="Wid120" size="small" placeholder="请输入" v-model="itemss.code"></el-input>
                                    </div>
                                    <div class="SupervisorItem">
                                        <div>电话</div>
                                        <el-input class="Wid120" size="small" placeholder="请输入" v-model="itemss.mobile"></el-input>
                                    </div>
                                    <div class="SupervisorItem" v-if="indexs==0"><el-button class="MarLe" type="primary" size="mini" @click="supervisorAdd(items)">添加</el-button></div>
                                    <div class="SupervisorItem" v-else><el-button class="MarLe" type="error" size="mini" @click="supervisorDel(items,indexs)">删除</el-button></div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="StepBtns">
            <div class="StepBtn" @click="ToggleStep('prve')" :class="{StpepDisabled:ConfigDisabled}">上一步</div>
            <div class="StepBtn" @click="ToggleStep('next')" :class="{StpepDisabled:ConfigDisabled}">{{ Number(TypeId) === 1 ? '保存本页并下一步' : '提交' }}</div>
        </div>
        <el-dialog 
      title="提示" 
      :visible.sync="TiShiBlon" 
      width="30%" 
      center 
      :show-close="false" 
      :close-on-click-modal="false" 
      :close-on-press-escape="false"
    >
      <span>{{ TiShiData }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="TiShiBlon = false">取消</el-button>
        <el-button type="primary" @click="GoToRegister">去注册</el-button>
      </span>
    </el-dialog>
    
    <!-- 新增：重复注册检查弹窗 -->
    <el-dialog 
      title="提示" 
      :visible.sync="duplicateCheckBlon" 
      width="20%" 
      center 
      :show-close="false" 
      :close-on-click-modal="false" 
      :close-on-press-escape="false"
    >
      <div style="white-space: pre-line; text-align: center;">{{ duplicateCheckData }}</div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="duplicateCheckBlon = false">取消</el-button> -->
        <el-button type="primary" @click="goToUserCenter">确认</el-button>
      </span>
    </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                ID:"",
                user_group_id:[],
                TypeData:[],
                TiShiBlon: false,
                FormData:"",
                SeleId:"",
                SeleData:[],
                TiShiData:"",
                ConfigDisabled:false,
                selected:"",
                selectedGroup8ItemIds:[],
                objList: {},
                // 编辑模式下：若接口返回没有 user_group，则允许选择注册级别
                hasUserGroup: false,
                // 新增：重复注册检查相关
                duplicateCheckBlon: false,
                duplicateCheckData: "",
                userRegisteredTypes: [], // 存储用户已注册的类型
            }
        },
        props:{
            id:"",
            TypeId:"",
            PageDisabled:false,
        },
        mounted() {
            this.ID = this.id;
            this.ConfigDisabled = this.PageDisabled;
            this.GetType();
            
            // 修改：在新建模式和编辑模式下都检查用户已注册的类型
            this.checkUserRegisteredTypes();
            
            if(this.TypeId == 1 && !this.$route.query.type){
                this.SeleId = "";
                this.user_group_id = "";
            }
            if(this.TypeId == 2 && !this.$route.query.type){this.user_group_id = []}
            if(this.$route.query.type){
                this.ConfigDisabled = false;
                var InfoData = JSON.parse(localStorage.getItem("InfoData"));
                console.log('SpecialtyInfo mounted: 获取到的数据:', InfoData);
                
                // 确保InfoData存在
                if (!InfoData) {
                    this.$message.error('数据获取失败，请返回重试');
                    this.$router.push('/UserInfo');
                    return;
                }
                
                this.ID = {id:InfoData.id};
                if(this.$route.query.type==1){
                    // 判断是否已有注册级别
                    this.hasUserGroup = !!(InfoData.user_group && InfoData.user_group.length > 0) || !!InfoData.user_group_id;
                    // 处理user_group信息
                    if (InfoData.user_group && InfoData.user_group.length > 0) {
                        this.user_group_id = InfoData.user_group[0].id;
                    } else {
                        this.user_group_id = InfoData.user_group_id;
                    }
                    
                    var Str = "";
                    
                    // 检查question字段是否存在
                    if (InfoData.question && Array.isArray(InfoData.question)) {
                        InfoData.question.forEach(item=>{
                            if(item.pid !=0){
                                Str = item.pid;
                            }
                        });
                    } else {
                        console.error('InfoData中没有question数组或格式不正确');
                    }
                    
                    this.SeleId = Str;
                    this.GetFormData(this.user_group_id);
                    
                    // 在GetFormData完成后等待一段时间，再显示注册类型
                    setTimeout(() => {
                        if(this.FormData && this.SeleId) {
                            this.ShowData(this.SeleId);
                            
                            // 处理数据
                            setTimeout(() => {
                                if(InfoData.question && this.SeleData) {
                                    console.log('开始处理InfoData.question数据');
                                    console.log('InfoData.question:', InfoData.question);
                                    console.log('当前SeleData:', this.SeleData);
                                    
                                    InfoData.question.forEach(item => {
                                        console.log('处理question项:', item);
                                        console.log('查找user_question_bank_id:', item.user_question_bank_id);
                                        
                                        // 在SeleData中查找匹配的项目
                                        let foundItem = null;
                                        let foundIndex = -1;
                                        
                                        // 先查找主项目
                                        this.SeleData.forEach((items, index) => {
                                            if(item.user_question_bank_id == items.id){
                                                foundItem = items;
                                                foundIndex = index;
                                                console.log('找到匹配项，ID:', items.id, '名称:', items.name);
                                            }
                                        });
                                        
                                        // 如果主项目没找到，查找子项目
                                        if (!foundItem) {
                                            this.SeleData.forEach((items, index) => {
                                                if(items.children && items.children.length > 0) {
                                                    items.children.forEach((childItem, childIndex) => {
                                                        if(item.user_question_bank_id == childItem.id) {
                                                            foundItem = childItem;
                                                            foundIndex = `${index}_${childIndex}`;
                                                            console.log('找到匹配的子项目，ID:', childItem.id, '名称:', childItem.name);
                                                        }
                                                    });
                                                }
                                            });
                                        }
                                        
                                        if (foundItem) {
                                            // 确保templatefile字段存在
                                            if (!foundItem.templatefile) {
                                                foundItem.templatefile = [];
                                            }
                                            
                                            if(foundItem.type==1||foundItem.type==4){
                                                try {
                                                    foundItem.file = typeof item.file === 'string' ? JSON.parse(item.file) : item.file || [];
                                                    console.log('设置file数据:', foundItem.file);
                                                } catch (e) {
                                                    console.error('解析file数据出错:', e);
                                                    foundItem.file = [];
                                                }
                                            }
                                                                                // 设置templatefile数据，不管template_file是否为空
                                    if(item.templatefile && item.templatefile !== '[]'){
                                        try {
                                            console.log('原始templatefile数据:', item.templatefile);
                                            foundItem.templatefile = typeof item.templatefile === 'string' ? JSON.parse(item.templatefile) : item.templatefile || [];
                                            console.log('设置templatefile数据:', foundItem.templatefile);
                                        } catch (e) {
                                            console.error('解析templatefile数据出错:', e);
                                            foundItem.templatefile = [];
                                        }
                                    }
                                            if(foundItem.type==2){
                                                // 修复：在编辑模式下直接设置值，不进行条件判断
                                                foundItem.val = item.answer || "";
                                            }
                                            if(foundItem.is_supervisor==1){
                                                foundItem.supervisor = item.supervisor || [{
                                                    name:"",
                                                    mobile:"",
                                                    code:"",
                                                }];
                                            }
                                        } else {
                                            console.warn('未找到匹配的项目，user_question_bank_id:', item.user_question_bank_id);
                                        }
                                    })
                                    console.log('处理完成后的SeleData:', this.SeleData);
                                    this.$forceUpdate();
                                    // 编辑模式（人员）进入后，数据加载完成即自动提交一次（仅调用接口，不跳转）
                                    this.autoSubmitIfEdit();
                                }
                            }, 500);
                        }
                    }, 500);
                }else{
                    // 判断是否已有注册级别（机构）
                    this.hasUserGroup = !!(InfoData.user_group && InfoData.user_group.length > 0) || !!InfoData.user_group_id;
                    // 处理机构注册的user_group数据
                    if (InfoData.user_group && InfoData.user_group.length > 0) {
                        // 将user_group数组中的id转换为字符串数组
                        this.user_group_id = InfoData.user_group.map(item => String(item.id));
                    } else if (InfoData.user_group_id) {
                        this.user_group_id = InfoData.user_group_id.split(",").map(id => String(id));
                    } else {
                        this.user_group_id = [];
                    }
                    this.GetFormData(this.user_group_id.join(','));

                    // 在GetFormData完成后等待一段时间，处理question数据
                    setTimeout(() => {
                        if(InfoData.question && this.SeleData) {
                            console.log('TypeId==2 开始处理InfoData.question数据');
                            console.log('InfoData.question:', InfoData.question);
                            console.log('当前SeleData:', this.SeleData);
                            
                            InfoData.question.forEach(item => {
                                console.log('处理question项:', item);
                                console.log('查找user_question_bank_id:', item.user_question_bank_id);
                                
                                // 在SeleData中查找匹配的项目
                                let foundItem = null;
                                let foundIndex = -1;
                                
                                // 先查找主项目
                                this.SeleData.forEach((items, index) => {
                                    if(item.user_question_bank_id == items.id){
                                        foundItem = items;
                                        foundIndex = index;
                                        console.log('找到匹配项，ID:', items.id, '名称:', items.name);
                                    }
                                });
                                
                                // 如果主项目没找到，查找子项目
                                if (!foundItem) {
                                    this.SeleData.forEach((items, index) => {
                                        if(items.children && items.children.length > 0) {
                                            items.children.forEach((childItem, childIndex) => {
                                                if(item.user_question_bank_id == childItem.id) {
                                                    foundItem = childItem;
                                                    foundIndex = `${index}_${childIndex}`;
                                                    console.log('找到匹配的子项目，ID:', childItem.id, '名称:', childItem.name);
                                                }
                                            });
                                        }
                                    });
                                }
                                
                                if (foundItem) {
                                    // 确保templatefile字段存在
                                    if (!foundItem.templatefile) {
                                        foundItem.templatefile = [];
                                    }
                                    
                                    if(foundItem.type==1||foundItem.type==4){
                                        try {
                                            foundItem.file = typeof item.file === 'string' ? JSON.parse(item.file) : item.file || [];
                                            console.log('设置file数据:', foundItem.file);
                                        } catch (e) {
                                            console.error('解析file数据出错:', e);
                                            foundItem.file = [];
                                        }
                                    }
                                    // 设置templatefile数据，不管template_file是否为空
                                    if(item.templatefile && item.templatefile !== '[]'){
                                        try {
                                            console.log('原始templatefile数据:', item.templatefile);
                                            foundItem.templatefile = typeof item.templatefile === 'string' ? JSON.parse(item.templatefile) : item.templatefile || [];
                                            console.log('设置templatefile数据:', foundItem.templatefile);
                                        } catch (e) {
                                            console.error('解析templatefile数据出错:', e);
                                            foundItem.templatefile = [];
                                        }
                                    }
                                    if(foundItem.type==2){
                                        foundItem.val = item.answer || "";
                                    }
                                    if(foundItem.is_supervisor==1){
                                        foundItem.supervisor = item.supervisor || [{
                                            name:"",
                                            mobile:"",
                                            code:"",
                                        }];
                                    }
                                } else {
                                    console.warn('未找到匹配的项目，user_question_bank_id:', item.user_question_bank_id);
                                }
                            })
                            console.log('TypeId==2 处理完成后的SeleData:', this.SeleData);
                            this.$forceUpdate();
                        }
                    }, 500);
                }
            }

            // 从 localStorage 读取保存的数据
            const savedData = localStorage.getItem('specialtyInfoData');
            if(savedData) {
                const parsedData = JSON.parse(savedData);
                if(parsedData.TypeId == this.TypeId) {
                    this.user_group_id = parsedData.user_group_id;
                    this.SeleData = parsedData.SeleData;
                    this.selected = parsedData.selected;
                    this.selectedGroup8ItemIds = parsedData.selectedGroup8ItemIds || [];
                    if(this.user_group_id) {
                        this.GetFormData(this.user_group_id);
                    }
                }
            }
        },
        computed: {
            isGroup8Selected() {
                return this.TypeId == 2 && Array.isArray(this.user_group_id) && this.user_group_id.includes('8');
            },
            group8Options() {
                if (!Array.isArray(this.SeleData)) return [];
                return this.SeleData
                    .filter(item => item.question_list_id == 8)
                    .map(item => ({ label: item.name, value: item.id }));
            }
        },
        methods: {
            // 修改：检查用户已注册的类型，支持机构和人员
            async checkUserRegisteredTypes() {
                try {
                    let apiUrl = '';
                    if (this.TypeId == 1) {
                        // 人员注册
                        apiUrl = "api/user/peopleSearch";
                    } else if (this.TypeId == 2) {
                        // 机构注册
                        apiUrl = "api/user/companySearch";
                    }
                    
                    if (!apiUrl) return;
                    
                    const res = await this.$get(apiUrl, {
                        page: 1
                    });
                    if (res.data.code === 1 && res.data.data && res.data.data.data) {
                        this.userRegisteredTypes = [];
                        res.data.data.data.forEach(item => {
                            if (item.user_group && item.user_group.length > 0) {
                                item.user_group.forEach(group => {
                                    this.userRegisteredTypes.push({
                                        id: group.id,
                                        name: group.name
                                    });
                                });
                            }
                        });
                        console.log('用户已注册的类型:', this.userRegisteredTypes);
                    }
                } catch (error) {
                    console.error('检查用户注册类型失败:', error);
                }
            },
            
            // 新增：检查是否重复注册
            checkDuplicateRegistration(selectedId) {
                // 移除编辑模式不检查的限制
                // if (this.$route.query.type) return false; // 编辑模式不检查
                
                const isDuplicate = this.userRegisteredTypes.some(type => type.id == selectedId);
                if (isDuplicate) {
                    const foundType = this.userRegisteredTypes.find(type => type.id == selectedId);
                    const typeName = foundType ? foundType.name : '该类型';
                    
                    // 编辑模式下的提示信息
                    if (this.$route.query.type) {
                        this.duplicateCheckData = `你已注册过${typeName}\n请选择其他注册级别`;
                    } else {
                        this.duplicateCheckData = `你已注册过${typeName}\n可以前往个人中心查看`;
                    }
                    
                    this.duplicateCheckBlon = true;
                    return true;
                }
                return false;
            },
            
            // 修改：ChangeData方法，添加重复检查
            ChangeData(val){
                // 检查是否重复注册
                if (this.TypeId == 1 && val && this.checkDuplicateRegistration(val)) {
                    return; // 如果重复注册，不继续执行
                }
                if (this.TypeId == 2 && Array.isArray(val)) {
                    // 对于多选，检查每个选中的项
                    for (let id of val) {
                        if (this.checkDuplicateRegistration(id)) {
                            return; // 如果任何一个重复，不继续执行
                        }
                    }
                }
                
                var blon = true;
                if(this.TypeId==2){
                    if(val.length==0){blon=false;this.SeleData=[]}
                    val = val.toString(val)
                }
                if(blon){this.GetFormData(val)}
                this.selected = ''
                this.SeleData = []
                this.selectedGroup8ItemIds = []
            },
            
            // 新增：跳转到个人中心
            goToUserCenter() {
                this.duplicateCheckBlon = false;
                let targetId = 2; // 默认人员注册
                if (this.TypeId == 2) {
                    targetId = 3; // 机构注册
                }
                
                this.$router.push({
                    path: '/UserInfo',
                    query: {
                        id: targetId
                    }
                });
            },
            
            GetType(){
               this.$get("api/join_in/getJoinInGroup",{
                   type:this.TypeId,
               }).then(res => {
                    if(res.data.code == 1){
                        this.TypeData = res.data.data;
                    }else{
                        this.$message.error(res.data.msg)
                    }
               })
            },
            GetFormData(val){
                this.$get("api/join_in/getRegisterInformation",{
                    page:2,
                    user_group_id:val,
                }).then(res => {
                     if(res.data.code == 1){
                         var Arr = [];
                         res.data.data.forEach(item=>{
                             item.question_list.forEach(items => {
                                 if(items.type == 1 || items.type == 4){
                                     items.file=[];
                                 }
                                 // 确保templatefile字段存在，编辑模式下不清空，新建模式下清空
                                 if(items.template_file != ''){
                                     if(!this.$route.query.type) {
                                         // 新建模式：清空templatefile
                                         items.templatefile=[];
                                     } else {
                                         // 编辑模式：确保字段存在，但不覆盖已有数据
                                         if(!items.templatefile) {
                                             items.templatefile=[];
                                         }
                                     }
                                 }
                                 if(items.is_supervisor ==1){
                                     items.supervisor=[{
                                         name:"",
                                         mobile:"",
                                         code:"",
                                     }]
                                 }
                                 if(items.children.length>0){
                                     items.children.forEach(itemss => {
                                         if(itemss.type == 1 || itemss.type == 4){
                                             itemss.file=[];
                                         }
                                         // 确保子项目的templatefile字段也存在
                                         if(itemss.template_file != ''){
                                             if(!this.$route.query.type) {
                                                 // 新建模式：清空templatefile
                                                 itemss.templatefile=[];
                                             } else {
                                                 // 编辑模式：确保字段存在，但不覆盖已有数据
                                                 if(!itemss.templatefile) {
                                                     itemss.templatefile=[];
                                                 }
                                             }
                                         }
                                         if(itemss.is_supervisor == 1){
                                             itemss.supervisor=[{
                                                 name:"",
                                                 mobile:"",
                                                 code:"",
                                             }]
                                         }
                                     })
                                 }
                                 items.question_list_id = item.id
                                 Arr.push(items)
                             })
                             var is_question_list_id = true
                             Arr.forEach(t => {
                                if (t.question_list_id == item.id && is_question_list_id) {
                                    t.question_list_id_one = item.id
                                    is_question_list_id = false
                                }
                            })
                         })
                         if(this.TypeId ==2){
                             this.SeleData = Arr;
                             if (Array.isArray(this.user_group_id) && this.user_group_id.includes('8')) {
                                 if (!Array.isArray(this.selectedGroup8ItemIds)) {
                                     this.selectedGroup8ItemIds = [];
                                 }
                             } else {
                                 this.selectedGroup8ItemIds = [];
                             }
                         }else{
                             this.FormData = Arr;
                             if(this.$route.query.type){
                                 this.ShowData(this.SeleId)
                             }
                         }
                         
                     }else{
                         this.$message.error(res.data.msg)
                     }
                })  
            },
            supervisorAdd(item){
                item.supervisor.push({
                     name:"",
                     mobile:"",
                     code:"",
                 })
            },
            supervisorDel(i,s){
                i.supervisor.splice(s,1)
            },
            ShowData(val){
                console.log('ShowData被调用，参数:', val);
                console.log('当前FormData:', this.FormData);
                this.SeleData = [];
                if(this.TypeId == 1){
                    this.FormData.forEach(item=>{
                        if(item.id == val){
                            console.log('找到匹配的FormData项:', item);
                            // 在编辑模式下使用深拷贝，避免数据丢失
                            if(this.$route.query.type) {
                                const deepCopy = JSON.parse(JSON.stringify(item));
                                console.log('深拷贝后的数据:', deepCopy);
                                this.SeleData.push(deepCopy);
                            } else {
                                this.SeleData.push(item);
                            }
                            this.selected = val;
                        }
                    })
                }else{
                   val.forEach(item=>{
                       this.FormData.forEach(items=>{
                           if(items.id == item){
                               this.SeleData.push(items)
                           }
                       })
                   })
                }
                console.log('ShowData完成后的SeleData:', this.SeleData);
            },
            async ToggleStep(s) {
                if (this.ConfigDisabled) return;

                // 保存表单数据到 localStorage，无论是点击上一步还是下一步
                const formData = {
                    TypeId: this.TypeId,
                    user_group_id: this.user_group_id,
                    SeleData: this.SeleData,
                    selected: this.selected,
                    selectedGroup8ItemIds: this.selectedGroup8ItemIds
                };
                localStorage.setItem('specialtyInfoData', JSON.stringify(formData));

                if (s === "next") {
                    try {
                        const res = await this.$get("api/join_in/xinXieUserInfo", {});
                        console.log('xinXieUserInfo response:', res.data);
                        if (res.data.code === -99) {
                            this.TiShiData = res.data.msg;
                            this.TiShiBlon = true;
                            this.ConfigDisabled = true;
                            return;
                        }
                        if (res.data.code !== 1) {
                            this.$message.error(res.data.msg);
                            return;
                        }

                        let num = 0;
                        let Arr = [];
                        let Quy = {};
                        let Url = "api/join_in/addCompanyQuestion";
                        let idObj = {};

                        if (this.TypeId == 2 && this.isGroup8Selected && this.selectedGroup8ItemIds.length === 0) {
                            this.$message.error('请选择至少一个项目');
                            return;
                        }
                        const iterateData = (this.TypeId == 2 && this.isGroup8Selected)
                            ? this.SeleData.filter(it => it.question_list_id != 8 || this.selectedGroup8ItemIds.includes(it.id))
                            : this.SeleData;

                        iterateData.forEach(item => {
                            let obj = {};
                            if (item.type == 1 || item.type == 4) {
                                obj.user_question_bank_id = item.id;
                                obj.answer = "";
                                obj.file = item.file;
                                obj.templatefile = item.templatefile || [];
                                // type为4时（其他文件）不进行必填验证
                                if (item.type == 1 && item.file.length == 0) num++;
                                // 模板上传为必填（当有模板上传入口时）
                                if ((item.is_template == 1 || item.is_template == '1') && (!Array.isArray(item.templatefile) || item.templatefile.length === 0)) {
                                    num++;
                                }
                            }
                            if (item.type == 2) {
                                obj.user_question_bank_id = item.id;
                                obj.answer = item.val || "";
                                obj.file = [];
                                obj.templatefile = item.templatefile || [];
                                if (item.val === undefined || item.val === "") num++;
                                // 模板上传为必填（当有模板上传入口时）
                                if ((item.is_template == 1 || item.is_template == '1') && (!Array.isArray(item.templatefile) || item.templatefile.length === 0)) {
                                    num++;
                                }
                            }
                            if (item.type == 3) {
                                obj.user_question_bank_id = item.id;
                                obj.answer = "";
                                obj.file = item.file || [];
                                obj.templatefile = item.templatefile || [];
                                // 模板上传为必填（当有模板上传入口时）
                                if ((item.is_template == 1 || item.is_template == '1') && (!Array.isArray(item.templatefile) || item.templatefile.length === 0)) {
                                    num++;
                                }
                            }
                            if (item.is_supervisor == 1) {
                                obj.user_question_bank_id = item.id;
                                obj.supervisor = this.processSupervisorData(item.supervisor);
                                obj.file = item.file || [];
                                obj.templatefile = item.templatefile || [];
                                
                                // 督导师字段验证已移除
                                // 若督导师条目同时开启模板上传，也需校验
                                if ((item.is_template == 1 || item.is_template == '1') && (!Array.isArray(item.templatefile) || item.templatefile.length === 0)) {
                                    num++;
                                }
                            }
                            if (this.TypeId == 1) {
                                if (obj.user_question_bank_id) Arr.push(obj);
                            } else {
                                if (obj.user_question_bank_id) Arr.push({ [item.question_list_id]: [obj] });
                            }

                            if (item.children.length > 0) {
                                item.children.forEach(items => {
                                    let objs = {};
                                    if (items.type == 1 || items.type == 4) {
                                        objs.user_question_bank_id = items.id;
                                        objs.answer = "";
                                        objs.file = items.file || [];
                                        objs.templatefile = items.templatefile || [];
                                        // type为4时（其他文件）不进行必填验证
                                        if (items.type == 1 && items.file.length == 0) num++;
                                        // 模板上传为必填（当有模板上传入口时）
                                        if ((items.is_template == 1 || items.is_template == '1') && (!Array.isArray(items.templatefile) || items.templatefile.length === 0)) {
                                            num++;
                                        }
                                    }
                                    if (items.type == 2) {
                                        objs.user_question_bank_id = items.id;
                                        objs.answer = items.val || "";
                                        objs.file = [];
                                        objs.templatefile = items.templatefile || [];
                                        if (items.val === undefined || items.val === "") num++;
                                        // 模板上传为必填（当有模板上传入口时）
                                        if ((items.is_template == 1 || items.is_template == '1') && (!Array.isArray(items.templatefile) || items.templatefile.length === 0)) {
                                            num++;
                                        }
                                    }
                                    if (items.type == 3) {
                                        objs.user_question_bank_id = items.id;
                                        objs.answer = items.val || "";
                                        objs.file = items.file || [];
                                        objs.templatefile = items.templatefile || [];
                                        // 模板上传为必填（当有模板上传入口时）
                                        if ((items.is_template == 1 || items.is_template == '1') && (!Array.isArray(items.templatefile) || items.templatefile.length === 0)) {
                                            num++;
                                        }
                                    }
                                    if (items.is_supervisor == 1) {
                                        objs.user_question_bank_id = items.id;
                                        objs.supervisor = this.processSupervisorData(items.supervisor);
                                        objs.file = items.file || [];
                                        objs.templatefile = items.templatefile || [];
                                        // 若督导师条目同时开启模板上传，也需校验
                                        if ((items.is_template == 1 || items.is_template == '1') && (!Array.isArray(items.templatefile) || items.templatefile.length === 0)) {
                                            num++;
                                        }
                                    }
                                    if (this.TypeId == 1) {
                                        if (objs.user_question_bank_id) Arr.push(objs);
                                    } else {
                                        if (objs.user_question_bank_id) Arr.push({ [item.question_list_id]: [objs] });
                                    }
                                });
                            }
                        });

                        if (this.TypeId == 1) {
                            Url = "api/join_in/addInformationQuestion";
                            Quy.register_professional_id = this.ID.id;
                            Quy.user_group_id = this.user_group_id;
                            Quy.pid = this.selected; // 添加pid参数，使用selected作为pid值
                            Quy.body_json = JSON.stringify(Arr);
                        } else {
                            Url = "api/join_in/addCompanyQuestion";
                            Quy.register_major_company_id = this.ID.id;
                            Quy.user_group_id = this.user_group_id.join(",");
                            Arr.forEach(item => {
                                for (let key in item) {
                                    if (!idObj[key]) idObj[key] = [];
                                    idObj[key].push(item[key][0]);
                                }
                            });
                            let result = [];
                            for (let key in idObj) {
                                result.push({ [key]: idObj[key] });
                            }
                            Quy.body_json = JSON.stringify(result);
                        }

                        if (num > 0) {
                            this.$message.error("题目作答或上传文件不能为空");
                            return;
                        }

                        const postRes = await this.$post(Url, Quy);
                        console.log('Post response:', postRes.data);
                        if (postRes.data.code == 1) {
                            this.$message.success(postRes.data.msg);
                            
                            // 编辑模式下删除InfoData和specialtyInfoData（仅机构注册）
                            if (this.$route.query.type && this.TypeId == 2) {
                                localStorage.removeItem('InfoData');
                                localStorage.removeItem('specialtyInfoData');
                            }
                            
                            if (this.TypeId == 1) {
                                let filteredObj = this.TypeData.find(obj => obj.id === Quy.user_group_id);
                                localStorage.setItem("filteredUrl", filteredObj.file_url);
                                console.log('Emitting PageBtn: next for TypeId == 1');
                                this.$emit("PageBtn", "next", this.user_group_id);
                            } else {
                                localStorage.setItem("filteredUrl", '');
                                this.GoBack();
                            }
                        } else {
                            this.$message.error(postRes.data.msg);
                        }
                    } catch (error) {
                        console.error('Error in ToggleStep:', error);
                        this.$message.error("请求失败，请稍后重试");
                    }
                } else {
                    console.log('Emitting PageBtn: prve');
                    this.$emit("PageBtn", "prve");
                }
            },
            OpenLock(res){
                this.$Global.previewFile(res)
            },
            CloseImg(type,i,is,s){
                // 添加防抖处理
                if (this._deleteTimeout) {
                    clearTimeout(this._deleteTimeout);
                }
                
                this._deleteTimeout = setTimeout(() => {
                    if(type=='fu'){
                        this.SeleData[i].file.splice(is,1)
                    }else{
                        this.SeleData[i].children[is].file.splice(s,1)
                    }
                    // 强制更新视图
                    this.$forceUpdate();
                }, 50); // 50ms防抖
            },
            CloseTempImg(type,i,is,s){
                // 添加防抖处理
                if (this._deleteTimeout) {
                    clearTimeout(this._deleteTimeout);
                }
                
                this._deleteTimeout = setTimeout(() => {
                    if(type=='fu'){
                        this.SeleData[i].templatefile.splice(is,1)
                    }else{
                        this.SeleData[i].children[is].templatefile.splice(s,1)
                    }
                    // 强制更新视图
                    this.$forceUpdate();
                }, 50); // 50ms防抖
            },
            UpFile(file, item, type) {
                // 只在 item.type == 1 或 item.type == 4 时进行文件格式验证
                if (item.type == 1 || item.type == 4) {
                    // 添加文件类型验证 - 只允许PDF和图片格式
                    const allowedTypes = [
                        'application/pdf',
                        'image/jpeg',
                        'image/jpg',
                        'image/png',
                        'image/gif'
                    ];
                    
                    const allowedExtensions = ['.pdf', '.jpg', '.jpeg', '.png', '.gif'];
                    const fileName = file.file.name.toLowerCase();
                    const fileType = file.file.type;
                    
                    // 检查文件类型
                    const isValidType = allowedTypes.includes(fileType) || 
                                      allowedExtensions.some(ext => fileName.endsWith(ext));
                    
                    if (!isValidType) {
                        this.$message.error('只能上传 PDF、JPG、PNG 等格式的文件');
                        return;
                    }
                }
                
                var fd = new FormData()
                fd.append('file',file.file);
                this.$Global.FileUpData(fd,(res)=>{
                    if(item.type==1 && type==1){
                        item.file[0] = {
                            url:res.data.url,
                            name:res.data.name
                        };
                    }
                    if(item.type==4 && type==1){
                        item.file.push({
                            url:res.data.url,
                            name:res.data.name
                        });
                    }
                    if(type==2){
                        // 初始化templatefile数组（如果不存在）
                        if (!item.templatefile) {
                            item.templatefile = [];
                        }
                        
                        // 确保督导师项目可以上传模板文件
                        if (item.is_supervisor == 1 || item.is_template == 1) {
                            if (item.templatefile.length == 0) {
                                item.templatefile[0] = {
                                    url: res.data.url,
                                    name: res.data.name
                                };
                            } else {
                                // 如果已有文件，则添加到数组中
                                item.templatefile.push({
                                    url: res.data.url,
                                    name: res.data.name
                                });
                            }
                        } else {
                            item.templatefile = [];
                            item.templatefile[0] = {
                                url: res.data.url,
                                name: res.data.name
                            };
                        }
                    }
                    this.$forceUpdate();
                })
            },
            DownFile(res){
                window.open(this.$Global.CommImgHttp+res)
            },
            ChangeVal(item){
                // 只有当 standard_value 存在且不为空字符串时才进行验证
                if(item.standard_value && item.standard_value !== "" && item.standard_value !== null){
                    if(parseFloat(item.val) < parseFloat(item.standard_value)){
                        this.$message.error("不能低于" + item.standard_value);
                        // 不要重置值，让用户自己修改
                        // item.val = "";
                    }
                }
                this.$forceUpdate(); // 强制更新视图
            },
            //新增：在填写完成后进行校验，若小于 standard_value 则提示并强制重置
            ValidateOnComplete(item){
                if(item && item.standard_value !== undefined && item.standard_value !== null && item.standard_value !== ""){
                    const inputVal = parseFloat(item.val);
                    const standardVal = parseFloat(item.standard_value);
                    if(!isNaN(inputVal) && !isNaN(standardVal)){
                        if(inputVal < standardVal){
                            this.$message.error("不能低于" + item.standard_value);
                            item.val = "";
                        }
                    }
                }
                this.$forceUpdate();
            },
            //跳转
            GoPage(url) {
                this.$router.push({
                    path: url
                });
            },
            // 返回
            GoBack() {
                this.$router.push({
                    path: '/UserInfo',
                    query: {
                        id: 3
                    }
                })
            },
            GoToRegister() {
                this.TiShiBlon = false;
                window.location.href = "https://rps.camh.org.cn/#/UserInfo";
            },
            // 编辑模式（TypeId==1）进入组件后自动提交当前数据（仅调用接口，不跳转）
            async autoSubmitIfEdit(){
                try {
                    if(this.TypeId != 1) return;
                    if(!this.$route.query.type) return;
                    if(!this.ID || !this.ID.id) return;
                    if(!this.user_group_id) return;
                    if(!this.selected) return;
                    if(!Array.isArray(this.SeleData) || this.SeleData.length === 0) return;

                    let Arr = [];
                    this.SeleData.forEach(item => {
                        let obj = {};
                        if (item.type == 1 || item.type == 4) {
                            obj.user_question_bank_id = item.id;
                            obj.answer = "";
                            obj.file = item.file || [];
                        }
                        if (item.type == 2) {
                            obj.user_question_bank_id = item.id;
                            obj.answer = item.val || "";
                            obj.file = [];
                            obj.templatefile = item.templatefile || [];
                        }
                        if (item.type == 3) {
                            obj.user_question_bank_id = item.id;
                            obj.answer = "";
                            obj.file = item.file || [];
                            obj.templatefile = item.templatefile || [];
                        }
                        if (item.is_supervisor == 1) {
                            obj.user_question_bank_id = item.id;
                            obj.supervisor = this.processSupervisorData(item.supervisor || []);
                            obj.file = item.file || [];
                            obj.templatefile = item.templatefile || [];
                        }
                        if (obj.user_question_bank_id) Arr.push(obj);

                        if (Array.isArray(item.children) && item.children.length > 0) {
                            item.children.forEach(items => {
                                let objs = {};
                                if (items.type == 1 || items.type == 4) {
                                    objs.user_question_bank_id = items.id;
                                    objs.answer = "";
                                    objs.file = items.file || [];
                                }
                                if (items.type == 2) {
                                    objs.user_question_bank_id = items.id;
                                    objs.answer = items.val || "";
                                    objs.file = [];
                                    objs.templatefile = items.templatefile || [];
                                }
                                if (items.type == 3) {
                                    objs.user_question_bank_id = items.id;
                                    objs.answer = items.val || "";
                                    objs.file = items.file || [];
                                    objs.templatefile = items.templatefile || [];
                                }
                                if (items.is_supervisor == 1) {
                                    objs.user_question_bank_id = items.id;
                                    objs.supervisor = this.processSupervisorData(items.supervisor || []);
                                    objs.file = items.file || [];
                                    objs.templatefile = items.templatefile || [];
                                }
                                if (objs.user_question_bank_id) Arr.push(objs);
                            });
                        }
                    });

                    const Url = "api/join_in/addInformationQuestion";
                    const Quy = {
                        register_professional_id: this.ID.id,
                        user_group_id: this.user_group_id,
                        pid: this.selected,
                        body_json: JSON.stringify(Arr)
                    };

                    const postRes = await this.$post(Url, Quy);
                    console.log('Auto submit (edit mode, TypeId==1) response:', postRes && postRes.data);
                    if (postRes && postRes.data && postRes.data.code == 1) {
                        // 仅提示，不跳转
                        this.$message.success(postRes.data.msg || '已自动保存');
                    } else if (postRes && postRes.data) {
                        this.$message.error(postRes.data.msg || '自动保存失败');
                    }
                } catch (e) {
                    console.error('autoSubmitIfEdit error:', e);
                }
            },
            // 新增：处理supervisor数据，在编辑模式下过滤掉id字段
            processSupervisorData(supervisorArray) {
                if (!Array.isArray(supervisorArray)) return [];
                
                // 如果是编辑模式，过滤掉id字段
                if (this.$route.query.type) {
                    return supervisorArray.map(item => {
                        const { id, ...rest } = item;
                        return rest;
                    });
                }
                
                // 新建模式，直接返回原数据
                return supervisorArray;
            },
            handleInputChange(item) {
                // 当输入框内容改变时，强制更新视图以触发 ValidateOnComplete
                this.$forceUpdate();
            }
        },
        watch: {
            TypeId: function (val) {
                this.ConfigDisabled = this.PageDisabled;
                this.user_group_id = "";
                this.FormData = "";
                if(val==1){this.SeleId="";this.user_group_id="";}else{this.user_group_id=[];}
                this.SeleData=[];
                this.selectedGroup8ItemIds = [];
                this.GetType();
            }
        }
    }
</script>

<style scoped>
    input[type="radio"] {
      accent-color: #0385EB;
      margin-top: 5px;
    }
    .StepJiBenRadio{
        margin-bottom: 5px;
        display: flex;
        align-items: flex-start;
    }
    .StepJiBenRadio .radio{
        cursor: pointer;
    }
    .StepJiBenRadio .radio-label {
       cursor: pointer;
       margin-left: 6px;
       font-size: 16px;
    }
    .MarTop {
        margin-top: 20px;
    }
    .MarLe{
        margin-left: 10px;
    }
    .MarTop40{
        margin-top: 40px;
    }
    .Wid120{
        width:120px;
        margin: 0 20px;
    }
    .Steps{
        display: none;
        align-items: center;
        margin: 30px 0;
        display: none;
    }
    .StepsItem{
        flex: 1;
        height: 50px;
        line-height: 50px;
        text-align: center;
        background: #F5F5F5;
        position: relative;
        font-weight: 400;
        font-size: 18px;
        color: #999;
    }
    .StepJiBen{
        /* margin:20px auto; */
        width: 80%;
    }
    .StepJiBen1{
        margin:20px auto;
        width: 40%;
    }
    .StepJiBenItem{
        display: flex;
        align-items: center;
        margin-bottom: 20px;
    }
    .StepJiBenItemTit{
        width: 200px;
        text-align: right;
        margin-right: 20px;
    }
    .StepJiBenItemTit1{
        width: 100px;
        text-align: right;
        margin-right: 20px;
    }
    .StepJiBenItemTit .Icon{
        color: #ff0000;
        font-weight: 400;
        font-size: 20px;
        margin-right: 5px;
    }
    .StepJiBenItemTit .Tit{
        font-weight: 400;
        font-size: 16px;
        color: #666;
    }
    .StepJiBenItemVal{
        flex: 1;
    }
    .StepJiBenItemVal .WidMax{
        width: 100%;
    }
    .StepJiBenItemVal.DisFlex{
        display: flex;
    }
    .StepHeadTit{
        padding: 10px 20px;
        font-weight: 400;
        font-size: 16px;
        color: #999999;
        background: #f5f5f5;
        margin-bottom: 50px;
    }
    .StepCommItem{
        display: flex;
        align-items: baseline;
    }
    .StepCommNum{
        font-weight: 400;
        font-size: 20px;
        color: #000000;
    }
    .StepCommHead{
        margin-left: 20px;
        flex: 1;
    }
    .StepCommFile{
        font-weight: 400;
        font-size: 16px;
        color: #666;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }
    .StepCommFileTxt{
        display: flex;
        align-items: center;
    }
    .StepCommFileBtn{
        font-size: 16px;
        padding: 3px 35px;
        background: #0185eb;
        border-radius: 5px;
        border: 1px solid #0185eb;
        text-align: center;
        cursor: pointer;
        /* margin-left: 20px; */
        color: #fff;
    }
    .StepCommFileMsg{
        font-weight: 400;
        font-size: 16px;
        color: #999999;
    }
    .StepCommFileLock{
        font-size: 16px;
        color: #0385EB;
        padding: 0 10px;
    }
    .StepCommFileImg{
        border: 1px solid #ddd;
        padding: 2px;
        cursor: pointer;
        position: relative;
        margin: 0 10px;
        display: inline-block;
    }
    .StepCommFileImg img{
        width: 50px;
        height: 50px;
        display: block;
    }
    .StepCommFileImg .iconfont{
        position: absolute;
        top: -8px;
        right: -8px;
        width: 16px;
        height: 16px;
        line-height: 16px;
        text-align: center;
        font-size: 12px;
        color: #fff;
        background-color: #ff4d4f;
        border-radius: 50%;
        cursor: pointer;
        z-index: 9;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .StepCommFileImg .iconfont::before {
        content: "×";
        font-size: 14px;
        font-weight: bold;
        transform: scale(1.2);
    }
    .StepCommFileImg .iconfont:hover {
        background-color: #ff7875;
    }
    .StepCommIpt{
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 16px;
        color: #666;
    }
    .StepCommIptVal{
        width: 80px;
        margin: 0 10px;
    }
    .StepCommIptMsg{
        margin-left: 10px;
        font-weight: 400;
        font-size: 16px;
        color:#0385EB;
    }
    .StepCommIpts{
        display: flex;
        align-items: baseline;
    }
    .StepCommIptsDis{
        display: flex;
        align-items: baseline;
    }
    .StepCommIptsTit{
        font-weight: 400;
        font-size: 20px;
        color: #000000;
        margin-right:20px;
    }
    .StepCommIptsHref{
        width: 65%;
    }
    .StepCommIptsHrefDis{
        flex: 1;
        margin-right: 40px;
    }
    .StepCommIptsHrefMsg{
        margin-top: 10px;
        cursor: pointer;
        font-weight: 400;
        font-size: 16px;
        color:#0385EB;
    }
    .StepCommIptsPass{
        flex: 1;
    }
    .StepBtns{
        display: flex;
        align-items: center;
        justify-content: center;
        margin:  30px 0
    }
    .StepBtn{
        margin-right: 20px;
        width: 180px;
        text-align: center;
        padding: 7px 15px;
        color: #fff;
        font-size: 18px;
        background: #0286eb;
        border-radius: 20px;
        cursor: pointer;
    }
    .StepBtn.StpepDisabled{
        background: #80c1f3;
        cursor: no-drop;
    }
    .SupervisorHead{
        display: flex;
        align-items: center;
        margin-bottom: 10px;
    }
    .SupervisorItem{
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 16px;
        color: #666;
    }
    .TitleBox {
        width: 100%;
        height: 40px;
        background-color: #F5F5F5;
        line-height: 42px;
        margin-top: 10px;
        text-align: center;
        font-size: 18px;
    }
    .RoundBox{
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #000000;
        margin: 0 10px 0 25px;
    }
    .StepFontWeight{
        font-weight: 600;
    }
    @media only screen and (max-width: 550px) {
       .Steps{
           display: flex;
       }
       .StepHeadTit{
           margin-bottom: 10px;
       }
       .StepCommFileDis{
           display: block;
       }
       .StepCommFileTxt{
           flex-wrap: wrap;
           font-size:18px;
       }
       .StepCommItem{
           margin-top: 20px;
       }
       .StepCommFile,
       .StepCommIpt{
           font-size:18px;
           flex-wrap: wrap;
       }
    }
</style>
<style>
    .StepJiBenBox .el-card__header{
        padding: 7px 0;
    }
    .StepJiBenBox .StepJiBenItemTit1{
        text-align: left !important;
        margin-left: 20px;
    }
    .StepJiBenItem .el-checkbox__label{
        font-size: 16px !important;
    }
    .TitleBoxAuto{
        height: auto !important;
        line-height: 24px !important;
        text-align: left !important;
        padding: 10px 20px;
        margin-bottom: 10px;
    }
</style>